<template>
    <loading-container v-if="!user" />
    <div v-else>
        <v-container fluid class="header ma-0">
        <v-container >
            <v-layout column>
            <v-row align="center" justify="center">

                <v-flex xs12 md12 class="mb-6 mx-0">
                <v-layout column align-left>
                    <a 
                    class="return-text"
                    @click="$router.go(-1)"
                    >
                    &larr; Volver al listado
                    </a>
                </v-layout>
                </v-flex>

                <v-layout column align-left>
                <p id="user_name">
                    {{user.name}}&nbsp;{{user.surname}}&nbsp;&lt;{{user.email}}&gt;
                <!-- <span
                    :class="user.is_intervened ? 'is-intervened-text' : 'not-intervened-text'"
                    v-html="user.is_intervened ? 'RESPONDIDO' : 'Pendiente de respuesta'"
                >
                </span> -->
                </p>
                <!-- <p id="user_national_id">
                    ID ASEGURADO: {{ user.insurance_id }}
                </p> -->
                </v-layout>
                <!-- <v-flex xs12 md6>
                <v-layout column align-end>
                    <v-btn class="app-button" id="symptoms-button" :color="getRiskBubbleColor(user)">
                    {{getNumberOfSymptomsText(user)}}
                    </v-btn>
                </v-layout> 
                </v-flex>-->
                <!-- <v-flex xs12 md12 class="mt-6 mx-0">
                <v-layout column align-left justify-center>
                    <p>
            
                    <span class="contact-text">
                        <svgicon icon="phone" width="1.75rem" height="1.75rem" color="#404a57"></svgicon>
                        {{ user.phone_number }}
                    </span>

                    <span class="admin-text ml-5"
                        v-html="user.admin ? 'USUARIO ASIGNADO A ' + (user.admin).toUpperCase() : 'USUARIO ACTUALMENTE NO ASIGNADO'"
                    />
        
                    </p>
                </v-layout>
                </v-flex> -->

            </v-row>
            </v-layout>
        </v-container>
        </v-container>

        <v-container fluid column>
        <v-container >
            <!-- <v-row>
            <v-col cols="12">
                <v-layout>
                <svgicon icon="symptoms" width="2.2rem" height="2.2rem" color="#1a4d63"></svgicon>
                <p class="section-title">Salud</p>
                </v-layout>
                <symptoms :user="user" :layout="'profile'" />
            </v-col>
            </v-row> -->
            <v-row>
            <v-col cols="12">
                <v-layout>
                <p class="section-title">	
                    Cuestionarios
                </p>
                </v-layout>
                <questionnaire :user_id="user.id" :layout="'profile'" />
            </v-col>
            </v-row>
            <!-- <v-row>
            <v-col cols="12">
                <v-layout>
                <svgicon icon="contact" width="2.2rem" height="2.2rem" color="#1a4d63"></svgicon>
                <p class="section-title">	
                    Contacto con el paciente
                </p>
                </v-layout>
                <contact-history :user="user" :layout="'profile'"/>
            </v-col>
            </v-row>
            <v-row>
            <v-col cols="12">
                <v-layout>
                <svgicon icon="profile" width="2.2rem" height="2.2rem" color="#1a4d63"></svgicon>
                <p class="section-title">Datos personales</p>
                </v-layout>
                <personal-data :user="user"/>
            </v-col>
            </v-row> -->
        </v-container>
        </v-container>
    </div>
</template>

<script>

// import Symptoms from '../components/Symptoms'
// import ContactHistory from '../components/ContactHistory'
// import PersonalData from '../components/PersonalData'
import Questionnaire from '../components/Questionnaire'

export default {
    name: "UserProfile",

    components: {
        // Symptoms,
        // ContactHistory,
        // PersonalData,
        Questionnaire
    },

    data () {
        return {
        }
    },
    computed: {
        user() {
        return this.$store.getters['users/current']
        },
    },

    beforeMount() {
        const userId = this.$route.params.id
        this.$store.dispatch('users/loadOne', userId)
        // this.$store.dispatch('contact_history/loadContactHistory', userId)
    },
}
</script>

<style lang="scss" scoped>
.header {
    min-height: 142px;
    background-color: #e2f3fb;
    width: 100%;

    #user_name {
        font-size: 1.9rem;
        font-weight: 600;
        margin-bottom: 0;
    }

    #user_national_id {
        color: #404a57;
    }

    .is-intervened-text {
        color: #29a8e3;
        font-weight: bold;
        font-size: 1.125rem;
        letter-spacing: 0;
    }

    .not-intervened-text {
        color: #aab2bd;
        font-weight: bold;
        font-size: 1.125rem;
        letter-spacing: 0;
    }

    .contact-text {
        font-weight: 600;
        color: #222c38;
        font-size: 1.125rem;
    }

    .admin-text {
        color: #12729a;
        font-weight: 600;
    }

    .return-text {
        color: #2d5b71;
        font-size: 0.925rem;
    }
}

.section-title {
    color: #1a4d63;
    font-size: 1.66rem;
    margin-right: 5px;
}

#symptoms-button {
    width: fit-content;
    pointer-events: none;
}
  
</style>